module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-murale-all.5e3cf337.jpg";